// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-panel {
  max-width: 800px;
  margin: 0 auto;
}

.settings-header {
  text-align: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #e9ecef;
}

.settings-header h2 {
  color: #333;
  margin-bottom: 0.5rem;
  font-size: 1.8rem;
}

.settings-header p {
  color: #666;
  font-size: 1rem;
}

.settings-content {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.settings-section {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-left: 4px solid #667eea;
}

.settings-section h3 {
  color: #333;
  margin-bottom: 1rem;
  font-size: 1.3rem;
  font-weight: 600;
}

.setting-group {
  margin-bottom: 1.5rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.setting-group:last-child {
  margin-bottom: 0;
}

.setting-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #333;
}

.setting-group select {
  width: 100%;
  max-width: 300px;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: white;
  font-size: 0.9rem;
  transition: border-color 0.3s ease;
}

.setting-group select:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

/* Custom Checkbox */
.checkbox-label {
  display: flex !important;
  align-items: center;
  cursor: pointer;
  font-weight: 500;
  color: #333;
  margin-bottom: 0 !important;
  position: relative;
  padding-left: 35px;
}

.checkbox-label input[type="checkbox"] {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  position: absolute;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #fff;
  border: 2px solid #ddd;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.checkbox-label:hover input ~ .checkmark {
  border-color: #667eea;
}

.checkbox-label input:checked ~ .checkmark {
  background-color: #667eea;
  border-color: #667eea;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.checkbox-label input:checked ~ .checkmark:after {
  display: block;
}

.checkbox-label .checkmark:after {
  left: 6px;
  top: 2px;
  width: 4px;
  height: 8px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

/* Settings Actions */
.settings-actions {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.btn-secondary {
  background: #6c757d;
  color: white;
}

.btn-secondary:hover {
  background: #5a6268;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(108, 117, 125, 0.3);
}

/* Settings Info */
.settings-info {
  margin-top: 1rem;
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-left: 4px solid #667eea;
}

.settings-info h3 {
  color: #333;
  margin-bottom: 1rem;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.info-item:last-child {
  border-bottom: none;
}

.info-label {
  font-weight: 500;
  opacity: 0.9;
}

.info-value {
  font-weight: 600;
  background: rgba(255, 255, 255, 0.2);
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.9rem;
}

/* Responsive Design */
@media (max-width: 768px) {
  .settings-panel {
    padding: 0 1rem;
  }
  
  .settings-section {
    padding: 1rem;
  }
  
  .settings-actions {
    flex-direction: column;
  }
  
  .btn {
    width: 100%;
    justify-content: center;
  }
  
  .info-grid {
    grid-template-columns: 1fr;
  }
  
  .info-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
}

/* Animations */
.settings-section {
  animation: slideInUp 0.6s ease-out;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.setting-group {
  animation: fadeIn 0.5s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Hover Effects */
.settings-section:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}

.setting-group:hover {
  background: #e9ecef;
  border-color: #667eea;
  transition: all 0.3s ease;
}



/* Dark theme for settings panel */
.settings-section.dark-theme {
  background: #2d2d2d;
  border-left-color: #667eea;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.settings-section.dark-theme h3 {
  color: #ffffff;
}

.settings-section.dark-theme .setting-group {
  background: #3d3d3d;
  border-color: #555;
}

.settings-section.dark-theme .setting-group label {
  color: #ffffff;
}

.settings-section.dark-theme .setting-group select {
  background: #2d2d2d;
  border-color: #555;
  color: #ffffff;
}

/* Дополнительные стили для темной темы */
.dark-theme .settings-section {
  background: #2d2d2d !important;
  border-left-color: #667eea !important;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3) !important;
}

.dark-theme .settings-info {
  background: #2d2d2d !important;
  border-left-color: #667eea !important;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3) !important;
}

.dark-theme .settings-section h3 {
  color: #ffffff !important;
}

.dark-theme .setting-group {
  background: #3d3d3d !important;
  border-color: #555 !important;
}

.dark-theme .setting-group label {
  color: #ffffff !important;
}

.dark-theme .setting-group select {
  background: #2d2d2d !important;
  border-color: #555 !important;
  color: #ffffff !important;
}

.dark-theme .setting-group select:focus {
  border-color: #667eea !important;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2) !important;
}

.dark-theme .checkbox-label {
  color: #ffffff !important;
}

.dark-theme .checkmark {
  background-color: #2d2d2d !important;
  border-color: #555 !important;
}

.dark-theme .checkbox-label:hover input ~ .checkmark {
  border-color: #667eea !important;
}

.dark-theme .checkbox-label input:checked ~ .checkmark {
  background-color: #667eea !important;
  border-color: #667eea !important;
}

.dark-theme .setting-group:hover {
  background: #4a5568 !important;
  border-color: #667eea !important;
} `, "",{"version":3,"sources":["webpack://./src/components/settings/SettingsPanel.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,oBAAoB;AACpB;EACE,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;AACF;;AAEA,eAAe;AACf;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,kBAAkB;AAClB;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;AAC3B;;;;AAIA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,oDAAoD;AACtD;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,oDAAoD;AACtD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,yDAAyD;AAC3D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC","sourcesContent":[".settings-panel {\r\n  max-width: 800px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.settings-header {\r\n  text-align: center;\r\n  margin-bottom: 2rem;\r\n  padding-bottom: 1rem;\r\n  border-bottom: 2px solid #e9ecef;\r\n}\r\n\r\n.settings-header h2 {\r\n  color: #333;\r\n  margin-bottom: 0.5rem;\r\n  font-size: 1.8rem;\r\n}\r\n\r\n.settings-header p {\r\n  color: #666;\r\n  font-size: 1rem;\r\n}\r\n\r\n.settings-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2rem;\r\n}\r\n\r\n.settings-section {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 1.5rem;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n  border-left: 4px solid #667eea;\r\n}\r\n\r\n.settings-section h3 {\r\n  color: #333;\r\n  margin-bottom: 1rem;\r\n  font-size: 1.3rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.setting-group {\r\n  margin-bottom: 1.5rem;\r\n  padding: 1rem;\r\n  background: #f8f9fa;\r\n  border-radius: 8px;\r\n  border: 1px solid #e9ecef;\r\n}\r\n\r\n.setting-group:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.setting-group label {\r\n  display: block;\r\n  margin-bottom: 0.5rem;\r\n  font-weight: 500;\r\n  color: #333;\r\n}\r\n\r\n.setting-group select {\r\n  width: 100%;\r\n  max-width: 300px;\r\n  padding: 0.75rem;\r\n  border: 1px solid #ddd;\r\n  border-radius: 6px;\r\n  background: white;\r\n  font-size: 0.9rem;\r\n  transition: border-color 0.3s ease;\r\n}\r\n\r\n.setting-group select:focus {\r\n  outline: none;\r\n  border-color: #667eea;\r\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\r\n}\r\n\r\n/* Custom Checkbox */\r\n.checkbox-label {\r\n  display: flex !important;\r\n  align-items: center;\r\n  cursor: pointer;\r\n  font-weight: 500;\r\n  color: #333;\r\n  margin-bottom: 0 !important;\r\n  position: relative;\r\n  padding-left: 35px;\r\n}\r\n\r\n.checkbox-label input[type=\"checkbox\"] {\r\n  position: absolute;\r\n  opacity: 0;\r\n  cursor: pointer;\r\n  height: 0;\r\n  width: 0;\r\n}\r\n\r\n.checkmark {\r\n  position: absolute;\r\n  left: 0;\r\n  height: 20px;\r\n  width: 20px;\r\n  background-color: #fff;\r\n  border: 2px solid #ddd;\r\n  border-radius: 4px;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.checkbox-label:hover input ~ .checkmark {\r\n  border-color: #667eea;\r\n}\r\n\r\n.checkbox-label input:checked ~ .checkmark {\r\n  background-color: #667eea;\r\n  border-color: #667eea;\r\n}\r\n\r\n.checkmark:after {\r\n  content: \"\";\r\n  position: absolute;\r\n  display: none;\r\n}\r\n\r\n.checkbox-label input:checked ~ .checkmark:after {\r\n  display: block;\r\n}\r\n\r\n.checkbox-label .checkmark:after {\r\n  left: 6px;\r\n  top: 2px;\r\n  width: 4px;\r\n  height: 8px;\r\n  border: solid white;\r\n  border-width: 0 2px 2px 0;\r\n  transform: rotate(45deg);\r\n}\r\n\r\n/* Settings Actions */\r\n.settings-actions {\r\n  display: flex;\r\n  gap: 1rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.btn {\r\n  padding: 0.75rem 1.5rem;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-size: 0.9rem;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  text-decoration: none;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.btn-primary {\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: white;\r\n}\r\n\r\n.btn-primary:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\r\n}\r\n\r\n.btn-secondary {\r\n  background: #6c757d;\r\n  color: white;\r\n}\r\n\r\n.btn-secondary:hover {\r\n  background: #5a6268;\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 15px rgba(108, 117, 125, 0.3);\r\n}\r\n\r\n/* Settings Info */\r\n.settings-info {\r\n  margin-top: 1rem;\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 1.5rem;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n  border-left: 4px solid #667eea;\r\n}\r\n\r\n.settings-info h3 {\r\n  color: #333;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.info-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\r\n  gap: 1rem;\r\n}\r\n\r\n.info-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 0.5rem 0;\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.info-item:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.info-label {\r\n  font-weight: 500;\r\n  opacity: 0.9;\r\n}\r\n\r\n.info-value {\r\n  font-weight: 600;\r\n  background: rgba(255, 255, 255, 0.2);\r\n  padding: 0.25rem 0.75rem;\r\n  border-radius: 12px;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 768px) {\r\n  .settings-panel {\r\n    padding: 0 1rem;\r\n  }\r\n  \r\n  .settings-section {\r\n    padding: 1rem;\r\n  }\r\n  \r\n  .settings-actions {\r\n    flex-direction: column;\r\n  }\r\n  \r\n  .btn {\r\n    width: 100%;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .info-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  \r\n  .info-item {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 0.5rem;\r\n  }\r\n}\r\n\r\n/* Animations */\r\n.settings-section {\r\n  animation: slideInUp 0.6s ease-out;\r\n}\r\n\r\n@keyframes slideInUp {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(30px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.setting-group {\r\n  animation: fadeIn 0.5s ease-out;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n/* Hover Effects */\r\n.settings-section:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.setting-group:hover {\r\n  background: #e9ecef;\r\n  border-color: #667eea;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n\r\n\r\n/* Dark theme for settings panel */\r\n.settings-section.dark-theme {\r\n  background: #2d2d2d;\r\n  border-left-color: #667eea;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.settings-section.dark-theme h3 {\r\n  color: #ffffff;\r\n}\r\n\r\n.settings-section.dark-theme .setting-group {\r\n  background: #3d3d3d;\r\n  border-color: #555;\r\n}\r\n\r\n.settings-section.dark-theme .setting-group label {\r\n  color: #ffffff;\r\n}\r\n\r\n.settings-section.dark-theme .setting-group select {\r\n  background: #2d2d2d;\r\n  border-color: #555;\r\n  color: #ffffff;\r\n}\r\n\r\n/* Дополнительные стили для темной темы */\r\n.dark-theme .settings-section {\r\n  background: #2d2d2d !important;\r\n  border-left-color: #667eea !important;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3) !important;\r\n}\r\n\r\n.dark-theme .settings-info {\r\n  background: #2d2d2d !important;\r\n  border-left-color: #667eea !important;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3) !important;\r\n}\r\n\r\n.dark-theme .settings-section h3 {\r\n  color: #ffffff !important;\r\n}\r\n\r\n.dark-theme .setting-group {\r\n  background: #3d3d3d !important;\r\n  border-color: #555 !important;\r\n}\r\n\r\n.dark-theme .setting-group label {\r\n  color: #ffffff !important;\r\n}\r\n\r\n.dark-theme .setting-group select {\r\n  background: #2d2d2d !important;\r\n  border-color: #555 !important;\r\n  color: #ffffff !important;\r\n}\r\n\r\n.dark-theme .setting-group select:focus {\r\n  border-color: #667eea !important;\r\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2) !important;\r\n}\r\n\r\n.dark-theme .checkbox-label {\r\n  color: #ffffff !important;\r\n}\r\n\r\n.dark-theme .checkmark {\r\n  background-color: #2d2d2d !important;\r\n  border-color: #555 !important;\r\n}\r\n\r\n.dark-theme .checkbox-label:hover input ~ .checkmark {\r\n  border-color: #667eea !important;\r\n}\r\n\r\n.dark-theme .checkbox-label input:checked ~ .checkmark {\r\n  background-color: #667eea !important;\r\n  border-color: #667eea !important;\r\n}\r\n\r\n.dark-theme .setting-group:hover {\r\n  background: #4a5568 !important;\r\n  border-color: #667eea !important;\r\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
